<template lang="pug">
    
    .causessolve.block.block--blue

        .causessolve__decor(v-observe-visibility='rellaxBlockVisibilityChanged')
            img.causessolve__decor-item.causessolve__decor-space(
                :src='require("@/assets/img/space.png")'
                data-rellax-speed='2'
                data-rellax-percentage='0.5'
                )
            img.causessolve__decor-item.causessolve__decor-clouds(
                :src='require("@/assets/img/clouds.png")'
                data-rellax-speed='2'
                data-rellax-percentage='0.5'
                )
            img.causessolve__decor-item.causessolve__decor-space(
                :src='require("@/assets/img/space.png")'
                data-rellax-speed='4'
                data-rellax-percentage='0.5'
                )
            img.causessolve__decor-item.causessolve__decor-clouds(
                :src='require("@/assets/img/clouds.png")'
                data-rellax-speed='5'
                data-rellax-percentage='0.5'
                )
            img.causessolve__decor-item.causessolve__decor-space(
                :src='require("@/assets/img/space.png")'
                data-rellax-speed='3'
                data-rellax-percentage='0.5'
                )

        Causes(:data='data.causes')

        Solve(:data='data.solve')



</template>

<script>
import Rellax from 'rellax';

export default {
    name: 'CausesSolve',

    components: {
        Causes: () => import('@/components/Causes.vue'),
        Solve: () => import('@/components/Solve.vue')
    },

    props: {
        data: Object
    },

    methods: {
        initRellax() {
            this.rellax = new Rellax('.causessolve__decor-item', {
                center: false
            });
        },

        destroyRellax() {
            this.rellax.destroy();
            this.rellax = null;
        },

        rellaxBlockVisibilityChanged(isVisible) {
            if (isVisible) {
                this.initRellax();
            } else if (this.rellax) {
                this.destroyRellax();
            }
        }
    }
};
</script>

<style lang="scss">
@import '@/assets/css/vars.scss';

.causessolve {
    &__decor {
        overflow: hidden;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        pointer-events: none;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: stretch;

        &-space {
            width: 70vw;
            margin-left: 10vw;
        }

        &-clouds {
            width: 30vw;
        }
    }
}
</style>
